export enum EDebounceDelay {
  Input = 750,
  Range = 1000,
}
